import { convertToRupiah } from '../../../helper/Rupiah'

const VendorTableItem = (props) => {
  const data = props.data

  return (
    <tr>
      <td>{props.no}</td>
      <td>{data.project_id}</td>
      <td>{data.id_survey || '-'}</td>
      <td>{data.project_name}</td>
      <td>{data.client_name}</td>
      {props.dateColumns.map((c) => (
        <td key={c.key}>{data[c.key] || '-'}</td>
      ))}
      {props.showValue && (
        <td>{data.nilai_penawaran == null ? '-' : `Rp. ${convertToRupiah(data.nilai_penawaran)}`}</td>
      )}
      <td>Rp. {convertToRupiah(data.deposit)}</td>
      <td>{data.payment_method ? data.payment_method : '-'}</td>
      <td>{data.payment_channel ? data.payment_channel : '-'}</td>
      <td>{data.fee_transfer}</td>
    </tr>
  )
}

export default VendorTableItem
